import React, {useMemo} from 'react'
import styles from './DiceStats.module.scss'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {BarChart} from '../../BarChart'
import {T} from '../../../../../common/T'

export const DiceStats = () => {
    const {gameEndData} = useUIGameEndContext()

    const chartData = useMemo(() => gameEndData.endGameState.diceStats.map((item, index) => ({
        label: index + 2,
        value: item,
        barClassName: index + 2 === 7 ? styles.grayBar : null,
    })), [gameEndData])

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <T id={{key: 'strings:game.endGame.dice.rolls'}}/>
            </div>
            <BarChart chartData={chartData}/>
        </div>
    )
}
